export default {"src":"/_next/static/media/company.8e7ac89e.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};